import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setHeading } from "../../../redux/slice/headerSlice";

const ERPSyncDisable = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeading("ERP Sync Disabled"));
  }, []);

  return (
    <main>
      <div className="route-invoice redbg">
        <div className="route-invoice-top">
          <img src="/images/erp_sync_disabled.png" alt="" />
          ERP Sync Status
        </div>
        <div className="route-sync disabled">
          <img src="/images/disabled.png" alt="" />
          Sync is currently disabled
        </div>
        <p>
          You're missing out on <span className="redbg">1,000 points</span>{" "}
          daily rewards!
        </p>
      </div>

      <div className="route-box borderred">
        <span className="route-box-icon redbg">
          <img src="/images/rejected.png" alt="" />
        </span>
        <h4>ERP Sync Disabled</h4>
        <p>Your ERP sync has been inactive for 15 days</p>
      </div>

      <div className="route-details redbg">
        <h4 className="colorred">Impact Summary</h4>
        <ul className="colorred">
          <li>
            Last sync: <span>15 Dec 2024</span>
          </li>
          <li>
            Points missed: <span>15,000</span>
          </li>
          <li>
            Daily rewards paused: <span>1,000 points</span>
          </li>
          <li>
            Connected ERP: <span>Tally (Disconnected)</span>
          </li>
        </ul>
        <Link to="" className="btn btn-block btn-gold mb-15">
          Re-enable Sync Now
        </Link>
        <Link to="" className="btn btn-block btn-white btn-color">
          View History
        </Link>
      </div>

      <div className="route-synchistory">
        <h4>Sync History</h4>
        <div className="route-synchistory-syncdisabled">
          <div className="route-synchistory-syncdisabled-header">
            <div className="route-synchistory-syncdisabled-header-left">
              <div className="route-synchistory-syncdisabled-header-left-image">
                <img src="/images/rejected.png" alt="" />
              </div>
              <div className="route-synchistory-syncdisabled-header-left-content">
                <h6>Sync Disabled</h6>
                <p>15 Dec 2024</p>
              </div>
            </div>
            <div className="route-synchistory-syncdisabled-header-right">
              <span>
                <img src="/images/connection-lost.png" alt="" />
                Connection Lost
              </span>
            </div>
          </div>
        </div>
        <div className="route-synchistory-syncwhy">
          <h4>Why should you re-enable?</h4>
          <ul>
            <li>Earn 1,000 points daily automatically</li>
            <li>No manual invoice uploads needed</li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default ERPSyncDisable;
